import { useState, useRef, useEffect, KeyboardEvent } from 'react';
import Checkbox from '../../UI/Checkbox/Checkbox';
import './filter.scss';

type SeasonFilter = 'all' | 'seasonless' | 'summer' | 'autumn' | 'winter' | 'spring';

interface IFilterProps {
    checkboxItemsFiller: { id: string; name: string; checked: boolean }[];
    onCheck: (id: string) => void;
    checkboxItemsFabric?: { id: string; name: string; checked: boolean }[];
    onCheckFabric?: (id: string) => void;
    currentSeason?: SeasonFilter;
    onSeasonChange?: (season: SeasonFilter) => void;
    seasonOptions?: { value: SeasonFilter; label: string }[];
    groupFilterLabel?: string;
    groupFilterOptions?: { value: string; label: string }[];
    currentGroupOption?: string;
    onGroupOptionChange?: (value: string) => void;
}

const Filter: React.FC<IFilterProps> = ({
    checkboxItemsFiller,
    onCheck,
    checkboxItemsFabric = [],
    onCheckFabric,
    currentSeason = 'all',
    onSeasonChange,
    seasonOptions,
    groupFilterLabel,
    groupFilterOptions,
    currentGroupOption = 'all',
    onGroupOptionChange,
}) => {
    const [isSeasonOpen, setIsSeasonOpen] = useState(false);
    const [isFillerOpen, setIsFillerOpen] = useState(false);
    const [isFabricOpen, setIsFabricOpen] = useState(false);
    const [isGroupOpen, setIsGroupOpen] = useState(false);
    const seasonRef = useRef<HTMLDivElement | null>(null);
    const fillerRef = useRef<HTMLDivElement | null>(null);
    const fabricRef = useRef<HTMLDivElement | null>(null);
    const groupRef = useRef<HTMLDivElement | null>(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handleOutside = (e: MouseEvent) => {
            if (isSeasonOpen && seasonRef.current && !seasonRef.current.contains(e.target as Node)) {
                setIsSeasonOpen(false);
            }
            if (isFillerOpen && fillerRef.current && !fillerRef.current.contains(e.target as Node)) {
                setIsFillerOpen(false);
            }
            if (isFabricOpen && fabricRef.current && !fabricRef.current.contains(e.target as Node)) {
                setIsFabricOpen(false);
            }
            if (isGroupOpen && groupRef.current && !groupRef.current.contains(e.target as Node)) {
                setIsGroupOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, [isSeasonOpen, isFillerOpen, isFabricOpen, isGroupOpen]);

    const handleSeasonKey = (e: KeyboardEvent<HTMLElement>, value: SeasonFilter) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSeasonChange?.(value);
            setIsSeasonOpen(false);
        }
    };

    const handleGroupKey = (e: KeyboardEvent<HTMLElement>, value: string) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onGroupOptionChange?.(value);
            setIsGroupOpen(false);
        }
    };

    // Наполнитель (checkboxItemsFiller)
    // const checkedFillers = checkboxItemsFiller.filter((c) => c.checked);
    // const fillerLabel = checkedFillers.length === 0 ? 'Выбрать' : checkedFillers.length === 1 ? checkedFillers[0].name : `${checkedFillers.length} вида`;

    // Ткань (checkboxItemsFabric)
    // const checkedFabrics = checkboxItemsFabric.filter((c) => c.checked);
    // const fabricLabel = checkedFabrics.length === 0 ? 'Выбрать' : checkedFabrics.length === 1 ? checkedFabrics[0].name : `${checkedFabrics.length} вида`;

    const groupSelectedLabel = (() => {
        if (!groupFilterOptions || !groupFilterOptions.length) return 'Выбрать';
        if (currentGroupOption === 'all') return 'Все';
        return groupFilterOptions.find((o) => o.value === currentGroupOption)?.label ?? 'Выбрать';
    })();

    return (
        <div className={open ? 'filter filter_open' : 'filter'}>
            <button className="filter__button" onClick={() => setOpen((o) => !o)}>
                Фильтры
            </button>

            {/* Сезонный фильтр */}
            {seasonOptions && seasonOptions.length > 0 && onSeasonChange && (
                <div className="filter__dropdown" ref={seasonRef}>
                    <button
                        className="filter__dropdown-toggle"
                        aria-haspopup="listbox"
                        aria-expanded={isSeasonOpen}
                        onClick={() => setIsSeasonOpen((v) => !v)}
                        onKeyDown={(e) => {
                            if (e.key === 'Escape') setIsSeasonOpen(false);
                        }}
                    >
                        <span className="filter__dropdown-label">Сезон</span>
                        {/* <span className="filter__dropdown-selected">{seasonOptions.find((o) => o.value === currentSeason)?.label || 'Выбрать'}</span> */}
                        <img className={`filter__arrow ${isSeasonOpen ? 'open' : ''}`} src="/icons/new/arrow_down.svg" alt="" aria-hidden="true" />
                    </button>
                    <div className={`filter__dropdown-panel ${isSeasonOpen ? 'open' : ''}`} role="listbox" aria-label="Сезон">
                        {seasonOptions.map((opt, index) => (
                            <div
                                key={`${opt.value}-${index}`}
                                role="option"
                                aria-selected={currentSeason === opt.value}
                                tabIndex={0}
                                className={['filter__dropdown-item', currentSeason === opt.value ? 'active' : undefined].filter(Boolean).join(' ')}
                                onClick={() => {
                                    onSeasonChange(opt.value);
                                    setIsSeasonOpen(false);
                                }}
                                onKeyDown={(e) => handleSeasonKey(e, opt.value)}
                            >
                                <span className="filter__item-label">{opt.label}</span>
                                {currentSeason === opt.value && <span className="filter__checkmark">✓</span>}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Тип ткани (чекбоксы) */}
            {checkboxItemsFabric.length > 0 && (
                <div className="filter__dropdown" ref={fabricRef}>
                    <button className="filter__dropdown-toggle" aria-haspopup="true" aria-expanded={isFabricOpen} onClick={() => setIsFabricOpen((v) => !v)}>
                        <span className="filter__dropdown-label">Тип ткани</span>
                        {/* <span className="filter__dropdown-selected">{fabricLabel}</span> */}
                        <img className={`filter__arrow ${isFabricOpen ? 'open' : ''}`} src="/icons/new/arrow_down.svg" alt="" aria-hidden="true" />
                    </button>
                    <div className={`filter__dropdown-panel filter__dropdown-panel--multi ${isFabricOpen ? 'open' : ''}`} role="group" aria-label="Тип ткани">
                        <div className="filter__checkbox-list">
                            {checkboxItemsFabric.map((item, index) => (
                                <label key={`${index}-${item.id}`} className="filter__checkbox-item">
                                    <Checkbox label={item.name} checked={item.checked} onCheck={() => onCheckFabric?.(item.id)} />
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Тип наполнителя (чекбоксы) */}
            {checkboxItemsFiller.some((x) => !!x.id) && (
                <div className="filter__dropdown" ref={fillerRef}>
                    <button className="filter__dropdown-toggle" aria-haspopup="true" aria-expanded={isFillerOpen} onClick={() => setIsFillerOpen((v) => !v)}>
                        <span className="filter__dropdown-label">Наполнитель</span>
                        {/* <span className="filter__dropdown-selected">{fillerLabel}</span> */}
                        <img className={`filter__arrow ${isFillerOpen ? 'open' : ''}`} src="/icons/new/arrow_down.svg" alt="" aria-hidden="true" />
                    </button>
                    <div className={`filter__dropdown-panel filter__dropdown-panel--multi ${isFillerOpen ? 'open' : ''}`} role="group" aria-label="Тип наполнителя">
                        <div className="filter__checkbox-list">
                            {checkboxItemsFiller.map((item, index) => (
                                <label key={`${index}-${item.id}`} className="filter__checkbox-item">
                                    <Checkbox label={item.name} checked={item.checked} onCheck={() => onCheck(item.id)} />
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Групповой фильтр (Размер/Цвет/Комплектация) */}
            {groupFilterLabel && groupFilterOptions && onGroupOptionChange && (
                <div className="filter__dropdown" ref={groupRef}>
                    <button
                        className="filter__dropdown-toggle"
                        aria-haspopup="listbox"
                        aria-expanded={isGroupOpen}
                        onClick={() => setIsGroupOpen((v) => !v)}
                        onKeyDown={(e) => {
                            if (e.key === 'Escape') setIsGroupOpen(false);
                        }}
                    >
                        <span className="filter__dropdown-label">{groupFilterLabel}:</span>
                        <span className="filter__dropdown-selected">{groupSelectedLabel}</span>
                        <img className={`filter__arrow ${isGroupOpen ? 'open' : ''}`} src="/icons/new/arrow_down.svg" alt="" aria-hidden="true" />
                    </button>
                    <div className={`filter__dropdown-panel ${isGroupOpen ? 'open' : ''}`} role="listbox" aria-label={groupFilterLabel}>
                        <div
                            role="option"
                            aria-selected={currentGroupOption === 'all'}
                            tabIndex={0}
                            className={['filter__dropdown-item', currentGroupOption === 'all' ? 'active' : undefined].filter(Boolean).join(' ')}
                            onClick={() => {
                                onGroupOptionChange('all');
                                setIsGroupOpen(false);
                            }}
                            onKeyDown={(e) => handleGroupKey(e, 'all')}
                        >
                            <span className="filter__item-label">Все</span>
                            {currentGroupOption === 'all' && <span className="filter__checkmark">✓</span>}
                        </div>
                        {groupFilterOptions.map((opt, index) => (
                            <div
                                key={`${opt.value}-${index}`}
                                role="option"
                                aria-selected={currentGroupOption === opt.value}
                                tabIndex={0}
                                className={['filter__dropdown-item', currentGroupOption === opt.value ? 'active' : undefined].filter(Boolean).join(' ')}
                                onClick={() => {
                                    onGroupOptionChange(opt.value);
                                    setIsGroupOpen(false);
                                }}
                                onKeyDown={(e) => handleGroupKey(e, opt.value)}
                            >
                                <span className="filter__item-label">{opt.label}</span>
                                {currentGroupOption === opt.value && <span className="filter__checkmark">✓</span>}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Filter;
